<template>
	<div>
		<myheader :backFlag="true" :headTitle="headTitle"></myheader>
		<div class="header_extend_main" style="height: 100%;">
			<div class="header_extend_back" style="height: 3rem;"></div>
			<div class="header_extend_content margin_top_5">
				<div class="all_tips_content_card_padding8 ">
					<div class="text12 textcolor333 font_weight_bold">{{'印模名称：'+signetInfo.signetName}}</div>
					<div class="text12 textcolor333 font_weight_bold margin_top_5 ">
						{{'印模类型：'+signetInfo.signetTypeText}}
					</div>
				</div>
				<div class="all_tips_content_card_padding8 margin_top_8">
					<div class="display_flex">
						<span style="width: 60%;margin-top: .2rem;"
							class="display_block text14 textcolor666">印模图片</span>
						<span style="width: 40%;height: 1.6rem;"
							class="switchSignetImgStyle display_block display_flex">
							<span class="display_block text12 all_text_center"
								:class="{switchSignetImgStyleon:signetMakeStyle===0,switchSignetImgStyleoff:signetMakeStyle!==0}"
								@click="selectMakeType(0)">上传图片</span>
							<span class="display_block text12 all_text_center"
								:class="{switchSignetImgStyleon:signetMakeStyle!==0,switchSignetImgStyleoff:signetMakeStyle===0}"
								@click="selectMakeType(1)">一键生成</span>
						</span>
					</div>
					<div style="width: 90%;height: 8rem;border-radius: .2rem;border: 1px solid #999;margin: .5rem 5%;">
						<div v-if="signetMakeStyle === 0" class="all_text_center" style="padding-top: .5rem;">
							<van-uploader accept="image/*" v-model="imageFiles" :before-read="beforeRead"
								:after-read="afterRead" preview-size="7rem" :preview-full-image="imageFilePreview">
								<div v-show="imageFiles.length==0" style="justify-content: center; align-items: center;"
									class="vertical_flex">
									<div class="text14 textcolor666">上传企业印章图片</div>
									<img class="margin_top_5" style="width: 3rem; height: 3rem; "
										src="@/assets/images/fang_gallery.svg">
									<div class="text12 textcolor666 margin_top_5" style="padding: 0 5%;">
										建议上传扫描版印章图片，png格式，分辨率为120，宽高为210*210，大小不超过1.5M</div>
								</div>
							</van-uploader>
						</div>
						<div v-else class="display_flex" style="justify-content: center;">
							<div style="width: 8rem; height: 8rem;position: relative;">
								<img id="img" style="width: 8rem; height: 8rem; object-fit: fill;" :src="imgSrc">
								<img style="position: absolute;left: 0;top: 0;z-index: 10;width: 8rem; height: 8rem; object-fit: fill;"
									:src="imgWaterMarker">
							</div>
						</div>
					</div>
				</div>
				<div class="all_tips_bottom_card">
					<button class="all_button22 width_100 text16 bmain_active" @click="sumbit()">提交</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		Uploader,
		Field,
	} from 'vant';
	export default {
		components: {
			[Uploader.name]: Uploader,
			[Field.name]: Field,
		},
		data() {
			return {
				//
				headTitle: '添加印模图片',
				//企业id
				corpId: '',
				//
				signetId: '',
				//制作方式
				signetMakeStyle: 0,
				//选择印模
				imageFiles: [],
				//印模是否可以方法查看
				imageFilePreview: false,
				//生成印模base64
				imgSrc: '',
				//水印base64
				imgWaterMarker: '',
				//
				signetFileId: '',
				//是否修改过
				isMake: false,
				//
				signetInfo: '',
				//524288
				imageLimitSize: 204800,
			}
		},
		methods: {
			//提交
			sumbit() {
				if (this.signetMakeStyle === 0) {
					this.saveSignetImg()
				} else {
					this.uploadBase64(0, this.imgSrc)
				}
			},
			//
			saveSignetImg() {
				if (!this.signetFileId) {
					if (this.signetMakeStyle === 0) {
						this.$Toast('请重新选择印模图片！');
					} else {
						this.$Toast('提交失败，请重试！');
					}
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/corp/api/saveSignetImg', {
						signetId: this.signetInfo.signetId,
						isGenerate: this.signetMakeStyle === 0 ? true : false,
						signetFileId: this.signetFileId,
					})
					.then(res => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success) {
							this.$router.go(-1)
						} else {
							this.$Toast('提交失败，请重试！');
						}
					}).catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
						this.$Toast('提交失败，请重试！');
						console.log('saveSignetImg', err)
					})
			},
			//文件长传前
			beforeRead(file) {
				if (file.type === 'image/*') {
					this.$Toast('请选择图片文件');
					return false;
				}
				return true;
			},
			//文件长传后
			afterRead(file) {
				//console.log(file)
				//console.log(this.imageFiles)
				this.imageFilePreview = true
				if (file.file.size > this.imageLimitSize) {
					this.$store.dispatch(this.$LoadShow, true)
					this.Tool.compressImage(file, this.imageLimitSize, true).then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						this.uploadBase64(1, res, file)
					}).catch(err=>{
						this.$store.dispatch(this.$LoadShow, false)
						this.uploadBase64(1, file.content, file)
					})
				} else {
					this.uploadBase64(1, file.content, file)
				}
			},
			//上传印模图片
			uploadBase64(flag, data, file) {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/file/api/saveBase64?resId=' + this.Tool.generateUUID(), {
						base64Data: data,
						clearBg: flag,
						fileName: file ? this.getImage(file.file.name) : (this.Tool.generateUUID() + '.png')
					})
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.signetFileId = res.data.fileId
							if (file) {
								file.status = 'success';
								file.message = '上传成功';
							} else {
								this.saveSignetImg()
							}
						} else {
							if (file) {
								file.status = 'failed';
								file.message = '上传失败';
							} else {
								this.$Toast('提交失败！');
							}
						}
					}).catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
						if (file) {
							file.status = 'failed';
							file.message = '上传失败';
						} else {
							this.$Toast('提交失败！');
						}
						console.log('/file/api/saveBase64', err)
					})

			},
			//
			getImage(imageName) {
				return imageName.replace('.jpg', '.png').replace('.jpeg', '.png')
			},
			//选印模制作方式
			selectMakeType(type) {
				if (type === 1) {
					if (this.signetInfo) {
						this.imgSrc = this.Tool.createSeal(this.signetInfo.signetName, this.signetInfo.signetTypeText)
						this.imgWaterMarker = this.Tool.createWaterMarker()
					} else {
						this.$Toast('印模名称和印模类型不完整！');
					}
				}
				this.signetMakeStyle = type
			},
			//印模信息
			getEditSignet() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get("/corp/api/getEditSignet", {
					signetId: this.signetId
				}).then(res => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						// if (res.data.signetImg && res.data.signetImg.signetFileBase64) {
						// 	this.headTitle = '替换印模图片'
						// } else {
						// 	this.headTitle = '添加印模图片'
						// }
						if (!res.data.signetTypeText) {
							switch (res.data.signetType) {
								case 1:
									res.data.signetTypeText = '合同专用章'
									break;
								case 2:
									res.data.signetTypeText = '收货确认章'
									break;
								case 3:
									res.data.signetTypeText = '交货确认章'
									break;
								case 4:
									res.data.signetTypeText = '企业公章'
									break;
								case 5:
									res.data.signetTypeText = '人事专用章'
									break;
								case 6:
									res.data.signetTypeText = '招标专用章'
									break;
								case 7:
									res.data.signetTypeText = '非招标专用章'
									break;
							}
						}
						this.signetInfo = res.data
					} else {
						this.$Toast('获取印模信息失败！');
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast('获取印模信息失败！');
					console.log('getNewSignet', err)
				})
			},
			//初始化
			init() {
				this.corpId = this.$route.query.corpId
				this.signetId = this.$route.query.signetId
				let type = this.$route.query.type
				if (type === '1') {
					this.headTitle = '替换印模图片'
				} else {
					this.headTitle = '添加印模图片'
				}
				this.getEditSignet()
			},
			makeResize() {
				//键盘弹出
				if (this.clientHeight > 0 && document.body.clientHeight < this.clientHeight) {
					this.buttonShow = false
				} else {
					this.buttonShow = true
				}
			},
		},
		computed: {
			//获得高度
			resize() {
				if (this.clientHeight == 0) {
					this.clientHeight = document.body.clientHeight
				}
				// if (this.waterCanvasWidth === 250) {
				// 	this.waterCanvasWidth = document.getElementById('img').clientWidth
				// 	this.waterCanvasHeight = document.getElementById('img').clientHeight
				// 	//console.log(this.waterCanvasWidth, this.waterCanvasHeight)
				// }
			},
		},
		mounted() {
			this.init()
			window.addEventListener('resize', this.resize);
			window.addEventListener('resize', this.makeResize);
		},
		beforeDestroy() {
			this.$store.commit('changeSignetInfo', '')
		},
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	::v-deep .van-cell {
		padding: 10px .3rem;
	}

	::v-deep .van-image__img {
		object-fit: contain !important;
	}
</style>